import { useEffect, useState } from 'react';

// First-login prompts show one at a time, in this order.
const ORDER = ['language', 'consent', 'whatsnew', 'tour'];
const wanted = new Set();
const listeners = new Set();

const activeId = () => ORDER.find((id) => wanted.has(id)) || null;
const notify = () => listeners.forEach((fn) => fn(activeId()));

export const requestPrompt = (id) => { wanted.add(id); notify(); };
export const releasePrompt = (id) => { wanted.delete(id); notify(); };

// Returns true only while this prompt is at the head of the queue.
export const usePromptSlot = (id, wants) => {
  const [active, setActive] = useState(() => wants && activeId() === id);
  useEffect(() => {
    const fn = (head) => setActive(head === id);
    listeners.add(fn);
    if (wants) requestPrompt(id); else releasePrompt(id);
    return () => { listeners.delete(fn); releasePrompt(id); };
  }, [id, wants]);
  return active;
};
